export default {
  BUTTON: {
    APPLY: "应用\n",
    NONE: "无",
    SAVE_CHANGES: "保存更改",
    PROCEED: "继续",
    DISMISS: "关闭",
    CONNECT: "连接",
    CONNECT_WALLET: "连接钱包",
    DISCONNECT: "断开连接",
    LOGOUT: "注销",
    CLOSE: "关闭",
    SETTINGS: "设置",
    LAUNCH_APP: "启动应用程序",
    CONNECT_TO_PROCEED: "连接钱包",
    VIEW_DETAILS: "查看详情",
    REFRESH: "刷新",
    START_REGISTRATION: "开始注册",
    CANCEL: "取消",
    PRESS_ENTER: "按回车键",
    LEARN_MORE: "了解更多",
    CLOSE_WINDOW: "关闭窗口",
    SHOW_AVAILABLE_ONLY: "仅显示可用的",
    SHOW_AVAILABLE: "仅显示可用的",
    PROCEED_SEARCH: "正在搜索",
    DOWNLOAD: "下载",
    SHOW_ALL: "显示全部",
    DESELECT_ALL: "取消全选",
    SHOW_SELCTED: "显示选中的",
    LINK: "链接",
    CUSTOM_LINK: "自定义链接",
    SET_QR_LINK_ALL: "设置所有 QR 链接",
    SET_QR_LINK: 'Set QR Link',
    DISABLE_ALL: "禁用所有",
    DISABLE_QR_CODE: "禁用二维码",
    ENABLE_QR_CODE: "启用二维码",
    SET_QR_COLOR: "设置 QR 颜色",
    SET_COLOR: "设置颜色",
    SET_ALL_COLORS: "设置 QR 颜色",
    SET_PRICE: "设置价格",
    SET_PRICE_ALL: "设置价格所有",
    RESET: 'Reset',
    CHECK_PROFILE: "检查个人资料",
    GO_TO_DASHBOARD: "转到仪表板",
    GO_TO_HOME: "返回首页",
    VIEW_PROFILE: "查看个人资料",
    CHECK_DOMAINS: "检查域",
    TRANSACTION_DETAILS: "交易详情",
    BUY_NOW: "立即购买",
    CLEAR_HISTORY: "清除历史记录",
    DEFAULT: "默认",
    CUSTOM: "自定",
    FRACTIONALISE: "分解",
    MORE_INFO: "更多信息",
    LESS_INFO: "较少资讯",
    APPROVE: "批准",
    NEXT: "下一页",
    PENDING: "待付款",
    REMOVE: "移除",
    REMOVE_ALL_ITEMS: "移除所有项目",
    ADD_ALL_TO_CART: "将全部添加到购物车",
    BOOKMARK_ALL: "全部书签",
    DOWNLOAD_LIST: "下载列表",
    SHARE_LIST: "分享列表",
    MORE: "更多",
    CHANGE: "找零",
    TRY_AGAIN: "再试一次"
  },
  HEADER: {
    ABOUT: "关于",
    FAQ: "常见问题",
    BACK_TO_HOME: "返回首页",
    HOME: "主页",
    CATEGORIES: "物品类别",
    HELP_SUPPORT: "帮助与支持",
    HELP: "求助",
    CANCEL_REGISTRATION: "取消注册",
    PROFILE: "个人信息",
    SETTINGS: "设置",
    DOCS: "文档",
    DOCUMENTATIONS: "文件",
    CART: "购物车",
    BOOKMARKS: "书签",
    PAYMENTS_HISTORY: "付款历史",
    LIGHT_MODE: "日间模式",
    CUSTOM_RPC: "自定义 RPC",
    SETUP_REQUIRED: "需要设置",
    MANAGE_DOMAINS: "管理域",
    APPROVE: "批准",
    FEATURE_DISABLED: "禁用功能",
    ERROR: "错误"
  },
  IPFS: {
    INITIALISING: "正在启动 p2p",
    FINDING_PEERS: "查找节点",
    FAILED: "失败",
    READY: "准备好",
    PUBLISHING: "发布"
  },
  EVENTS: {
    TRANSFER: "转移",
    REGISTRATION: "登记",
    RENEWAL: "续费",
    SALE: "销售",
    MINT: "分钟数",
    BURN: "刻录"
  },
  GENERIC: {
    NETWORK_CHANGED_INCOMPATIBLE: "不支持网络。请更改您的网络。",
    IPNS_PUBLISHING_COMPLETED: "发布已完成！",
    PENDING_TRANSACTION_CERATED: "新交易已创建。请检查您的钱包。"
  },
  RENEWAL_DURATIONS: {
    ONE_WEEK: "1星期",
    ONE_MONTH: "1个月",
    THREE_MONTHS: "3个月",
    SIX_MONTHS: "6个月",
    ONE_YEAR: "1 年",
    TWO_YEARS: "2 年",
    THREE_YEARS: "3 年",
    FOUR_YEARS: "4 年",
    FIVE_YEARS: "5 年"
  },
  LABELS: {
    DOWNLOAD_DATA: "下载数据",
    SORT_BY_EXPIRATIONS: "按过期排序",
    SORT_BY_LATEST_REGISTRATIONS: "按最新注册排序",
    SORT_BY_LONGEST_DURATION: "按最长注册时间排序",
    PREMIUM: "高级版",
    ANALYTICS: "分析",
    AN_ERROR_HAS_OCCURED: "处理您的请求时出错。",
    STOREFRONT_READY_TO_DEPLOY: "您的商店前面已准备好部署。您的商店将位于：",
    ACCESS_STOREFRONT: "您现在可以访问您的店面：",
    BUY_ON: "购买于",
    MY_PROFILE: "查看我的资料",
    CREATE_STOREFRONT: "创建店面",
    SETUP_PRIMARY_DOMAIN: "设置主域",
    CHOOSE_A_PRIMARY_DOMAIN: "选择一个主域并将其链接到您的个人资料。选定的域将是您的个人资料链接。",
    CREATE_YOUR_STOREFRONT: "使用Predomain商店使用您的.eth名称创建您的前台商店。了解更多关于您商店前端的信息：",
    THIS_DOMAINS_IS_AVAILABLE_IN_MARKETPLACE: "此域在以下市场上可用",
    PURCHASE_DOMAINS: "购买域",
    OWNED_BY: "拥有者",
    SETUP_STOREFRONT: 'Setup Storefront',
    MANAGE_FEATURED_ITEMS: "管理精选项目",
    VISIT_STOREFRONT: "访问店面",
    OPTIONS: "设置",
    FEATURED_ITEMS: "特色项目",
    SORT_BY_CATEGORY: "按类别排序",
    SELECT_DOMAIN: "选择域名",
    SELECT_DOMAINS: "选择域名",
    RENEW_DOMAINS: "更新域",
    TRANSFER_DOMAINS: "传输域",
    BUYER: "购买方",
    PRICE: "价格",
    SALE: "销售",
    ACTIVITY: "活动",
    TOP_CATEGORIES: "顶级交易类别",
    TOTAL_ASSETS: "总资产：",
    MONTHLY_SALES: "每月销售",
    DAILY_VOLUME: "每日音量",
    MONTHLY_VOLUME: "每月音量",
    DAILY_SALES: "每日特惠",
    TOP_SALE: "最高销售",
    TOP_SALES: "最高销售",
    TOP_BUYER: "顶级买家",
    RECENT_SALES: "最近销售",
    SALES_ACTIVITY: "销售活动",
    ENTER_NAMES_TO_SEARCH: "输入要搜索的名称",
    NOT_AVAILABLE: "不可用",
    VOLUME: "音量",
    FLOOR: "地板",
    FILTER: "筛选",
    RENEWAL_DURATION: "更新持续时间",
    TRANSACTION: "交易",
    USER_PROFILE: "用户基本资料",
    FEATURE_DISABLED: "此功能在当前版本中已被禁用。",
    COMPLETE: "完成",
    ESTIMATED_COST: "成本预估",
    ADDRESS: "地址",
    TRANSFER: "转移",
    PLEASE_WAIT: "请稍等",
    SELECT_A_DOMAIN: "选择域",
    RENEW: "续费",
    MANAGE_DOMAINS: "管理域",
    SEARCH_FOR: "搜索文件",
    MANAGE: "展开",
    COLLECT: "收集",
    LANDING_TEXT: "开放源码，分散，Web3域名搜索，注册和市场。",
    PROFILE: "个人信息",
    GO_TO_PROFILE: "转到文件",
    SEARCH: "搜索",
    CONTAIN_ALPHABET: "包含字母表",
    CONTAIN_NUMBERS: "包含数字",
    CONTAIN_EMOJI: "包含表情",
    MIN_LENGTH: "最小长度",
    MAX_LENGTH: "最大长度",
    CONTAINING_KEYWORDS: "包含关键字",
    FILTERS: "筛选器",
    DOMAINS: "域",
    DOMAIN: "语义域",
    DOMAIN_HISTORY: "域名历史",
    EXPIRATION_DATE: "过期日期",
    REGISTRATION_DATE: "登记",
    CREATION_DATE: "创建日期",
    DETAILS: "详细信息",
    YOUR_DOMAINS: "您的域",
    PROCESSING: "处理中",
    LAYOUT: "布局",
    ENTER_SUFFIX: "输入后缀",
    ENTER_PREFIX: "输入前缀",
    CLICK: 'Click',
    CONNECT_TO_START: " 开始或 ",
    TIP: 'Tip',
    ACTION: "运动",
    ACTIONS: "操作",
    ADVANCED_SEARCH_TIP: "使用新行或逗号分隔你的域名。",
    ADVANCED_SEARCH: "高级搜索",
    ADVANCED_MODE: "高级模式",
    REGISTER_DOMAINS_TO: "注册域名到",
    NO_DOMAINS_SELECTED: "未选择域名。",
    FIND_AND_REGISTER: "注册域，例如 domain1, domain2...",
    SELECTED_DOMAINS: "选定域",
    REGISTER: "注册",
    BOOKMARKS: "书签",
    SEARCH_RESULTS: "搜索结果",
    PROCEED_TO_REGISTRATION: "继续注册",
    REGISTER_DOMAINS: "注册域名到",
    REGISTRANT_ADDRESS: "注册地址",
    SET_RESOLVER: "设置解析器",
    TOTAL_COST: "总成本",
    GAS_PRICE: "煤气价格",
    NO_ADDRESS_DETECTED: "未检测到地址。",
    DURATION: "期限",
    NOTICE_SELECT_AN_RPC: "注意：选择一个将在应用程序中使用的RPC来替换默认的 RPC 提供商。",
    ENABLE_LIGHT_MODE: "启用光布局风格。",
    CLICK_NEXT_TO_PROCEED: "点击 <b>下一个</b> 继续。"
  },
  REGISTRATION: {
    REGISTRATION_CANCELLED_TITLE: "注册已取消",
    REGISTRATION_CANCELLED_DESCRIPTION: "您的注册已被取消。",
    CANCEL_REGISTRATION_TITLE: "取消注册",
    CANCEL_REGISTRATION_DESCRIPTION: "您确定要取消此注册吗？此操作不能撤消。",
    BEFORE_COMMIT: "第 1 步：请求注册。",
    COMMIT_SENT: "正在处理请求...",
    COMMIT_COMPLETE: "第 1 步：请求注册。",
    AWAIT: "正在处理请求...",
    BEFORE_REGISTRATION: "完成注册。",
    REGISTRATION_SENT: "正在完成注册...",
    REGISTRATION_COMPLETE: "登记!",
    REGISTRATION_COMPLETE_TITLE: "登记",
    YOUR_DOMAINS_HAVE_NOW_BEEN_REGISTERED: "您的域名已被注册。",
    BASKET_EMPTY: "您的篮子是空的",
    PLEASE_SELECT_DOMAINS_TO_REGISTER: "请选择要注册的新域名。"
  },
  PAYMENT: {
    PAYMENT_CANCELLED: "交易已取消。请重试。"
  },
  SPINNER: {
    SETUP_COMPLETE: "设置完成",
    LEDGER_NO_DEVICE_SELECTED: "连接到您的钱包时发生错误。请再试一次。",
    NO_DATA_TO_DISPLAY: "没有要显示的项目。",
    PERFORMING_SEARCH: "正在执行搜索...",
    LOADING_DATA: "正在加载数据...",
    FOLLOW_THE_INSTRUCTIONS_ON_YOUR_WALLET: "请按照你钱包中的说明继续操作。"
  },
  FORM_LABELS: {
    ENTER_DURATION: "输入持续时间",
    ENTER_QR_LINK: "输入自定义 QR 代码 URL",
    ENTER_PRICE: "输入价格",
    ENTER_CUSTOM_ADDRESS: "输入自定义地址",
    ENTER_RECEIVER_ADDRESS: "输入收件人地址"
  },
  FORM_ERRORS: {
    INVALID_DURATION: "无效时长",
    INVALID_QR_LINK: "无效的 URL，请重试。",
    INVALID_PRICE: "价格无效，请重试。",
    NO_ADDRESS_DETECTED: "未检测到地址，请重试。",
    INVALID_ADDRESS: "无效的地址，请重试。"
  },
  STEP: {
    STEP_1: "第一步",
    STEP_2: "第 2 步",
    STEP_3: "第 3 步",
    STEP_4: "第 4 步",
    STEP_5: "第 5 步"
  },
  RENEW: {
    RENEWAL_COST: "更新成本",
    ESTIMATED_RENEWAL_COST: "下面是这笔交易的估计更新费用。",
    RENEWAL_COMPLETE: "更新完成",
    DOMAINS_READY_FOR_RENEWAL: " 您的域名已准备就绪。要完成更新，请按下继续。"
  },
  TRANSFER: {
    TRANSFER_TO: "转账到",
    TRANSFER_COMPLETE: "传输完成！",
    SETUP_INSTRUCTION: "要启用ENS域管理，您的帐户必须配置为批准域转让。",
    CONTRACT_APPROVAL_NOTE: "合同批准允许合同代表您进行域转让。",
    DOMAINS_READY_FOR_TRANSFER: "您的域名已准备好传输。请输入接收者的地址并按下继续。"
  }
};